import React, { useState } from "react";

import SimRatingForm from "./SimRatingForm";
import "./SimFeedback.css";
import { useLanguage } from "../../i18n/LanguageContext";

/**
 * Shown once the SIM has actually carried data — only then can the customer
 * judge the connection. Before that the install card runs instead.
 */
export default function SimReviewCard({ simId, regionName, smdpStatus, existing }) {
    const [dismissed, setDismissed] = useState(false);
    const { t } = useLanguage();

    if (dismissed) return null;

    return (
        <div className="ed-card ed-fb">
            <div className="ed-fb-head">
                <div className="ed-fb-headtext">
                    <h2 className="ed-fb-title">{t("review.title")}</h2>
                    <p className="ed-fb-body">
                        {t("review.body")}
                    </p>
                </div>
                <button
                    type="button"
                    className="ed-fb-dismiss"
                    onClick={() => setDismissed(true)}
                    aria-label={t("common.close")}
                >
                    ×
                </button>
            </div>

            <SimRatingForm
                simId={simId}
                kind="SERVICE"
                smdpStatus={smdpStatus}
                question={regionName ? t("review.questionRegion", { region: regionName }) : t("review.question")}
                existing={existing}
            />
        </div>
    );
}
